module.exports = __webpack_public_path__ + "img/ic_file_setting_1_active.49fbcf5d.svg";